<div class="header-box" [ngClass]="id ? 'with-info-box' : ''">
  <div class="d-flex align-items-center heading-box">
    <ng-icon
      [name]="mode == 'view' ? 'heroUserCircle' : (mode == 'edit' ? 'heroUserCircle' : 'heroUserPlus')"></ng-icon>
    <div>
      <h2 *ngIf="mode"><small>{{ mode + ' User' | titlecase }}</small></h2>
      <h2 *ngIf="formLoading; else loaded"><ngx-skeleton-loader
          [theme]="{ height: '20px', width: '200px'}"></ngx-skeleton-loader></h2>
      <ng-template #loaded>
        <h2>{{ id ? (userData.firstName +
          (userData.middleName ? ' ' + userData.middleName + ' ' : ' ') + userData.lastName | titlecase) : 'Add User' }}
        </h2>
      </ng-template>
    </div>
  </div>
  <div class="d-flex justify-content-end align-items-center col-md-6 p-0">
    <button color="accent" mat-raised-button
      *ngIf="userService.permissionsValue['_USER_MANAGEMENT_EDIT_'] && mode == 'view'"
      [routerLink]="['/app/user','edit',id]">
      Edit User</button>
  </div>
</div>
<div class="info-box" *ngIf="id">
  <div class="info-section">
    <h3><small>Employee Id</small></h3>
    <h3 *ngIf="formLoading; else loadedEid"><ngx-skeleton-loader
        [theme]="{ height: '15px', width: '150px'}"></ngx-skeleton-loader></h3>
    <ng-template #loadedEid>
      <h3>{{userData.employeeId}}</h3>
    </ng-template>
  </div>
  <div class="info-section">
    <h3><small>Tenant Id</small></h3>
    <h3 *ngIf="formLoading; else loadedId"><ngx-skeleton-loader
        [theme]="{ height: '15px', width: '150px'}"></ngx-skeleton-loader></h3>
    <ng-template #loadedId>
      <h3>{{userData.tenantId}}</h3>
    </ng-template>
  </div>
  <div class="info-section">
    <h3><small>Status</small></h3>
    <h3 *ngIf="formLoading; else loadedStatus"><ngx-skeleton-loader
        [theme]="{ height: '15px', width: '150px'}"></ngx-skeleton-loader></h3>
    <ng-template #loadedStatus>
      <h3>{{userData.status == 0 ? 'Inactive' : 'Active'}}</h3>
    </ng-template>
  </div>
  <div class="info-section" *ngIf="mode">
    <h3><small>Created By</small></h3>
    <h3 *ngIf="formLoading; else loadedName"><ngx-skeleton-loader
        [theme]="{ height: '15px', width: '150px'}"></ngx-skeleton-loader></h3>
    <ng-template #loadedName>
      <h3>{{userData.createdBy | titlecase}}</h3>
    </ng-template>
  </div>
</div>
<div class="inner-box">
  <mat-card class="hide-stepper">
    <mat-card-content class="form-head">
      <div *ngIf="formLoading; else show">
        <ngx-skeleton-loader [theme]="{ height: '80px', width: '70%', margin: '0 auto'}"></ngx-skeleton-loader>
        <div class="pt-3">
          <ngx-skeleton-loader [theme]="{ height: '40px', 'width': '95%', margin: '0 auto'}"></ngx-skeleton-loader>
        </div>
        <div class="pt-3">
          <ngx-skeleton-loader [theme]="{ height: '40px', 'width': '95%', margin: '0 auto'}"></ngx-skeleton-loader>
        </div>
        <div class="pt-3">
          <ngx-skeleton-loader [theme]="{ height: '40px', 'width': '95%', margin: '0 auto'}"></ngx-skeleton-loader>
        </div>
        <div class="pt-4 mr-4">
          <ngx-skeleton-loader [theme]="{ height: '50px', width: '10%', float: 'right'}"></ngx-skeleton-loader>
          <ngx-skeleton-loader
            [theme]="{ height: '50px', width: '30px', opacity: '0', float: 'right', visibility: 'hidden'}"></ngx-skeleton-loader>
          <ngx-skeleton-loader [theme]="{ height: '50px', width: '10%', float: 'right'}"></ngx-skeleton-loader>
        </div>
      </div>
      <ng-template #show>
        <mat-stepper linear="true" #stepper [disableRipple]="true">
          <mat-step [stepControl]="userForm">
            <form [formGroup]="userForm">
              <mat-accordion>
                <mat-expansion-panel expanded hideToggle>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      Basic Information
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="col-md-12 align-items-center d-flex p-0">
                    <div class="col-md-2 d-flex justify-content-center profile-pic">
                      <div>
                        <a (click)="triggerFileInput()" [disabed]="isLoading" [matTooltip]="'Change Profile Picture'"
                          [matTooltipShowDelay]="300" [matTooltipHideDelay]="100">
                          <mat-spinner *ngIf="isLoading" diameter="18" color="accent"></mat-spinner>
                          <ng-icon name="heroCamera" *ngIf="!isLoading"></ng-icon>
                        </a>
                        <input type="file" accept="image/*" #fileInput style="display: none"
                          (change)="onFileSelected($event)">
                        <img [src]="selectedImage ? selectedImage.toString() : (base64Image ? base64Image : '/assets/img/img_avatar.png')" class="rounded-circle">
                      </div>
                    </div>
                    <div class="col-md-10 p-0 flex-wrap d-flex">
                      <div class="col-md-4">
                        <div class="dense-2">
                          <mat-form-field appearance="outline">
                            <mat-label>Employee Id</mat-label>
                            <input type="text" matInput autocomplete="off" formControlName="employeeId"
                              [errorStateMatcher]="matcher">
                            <mat-error *ngIf="userForm.get('employeeId').hasError('required')">
                              Employee Id is required
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="dense-2">
                          <mat-form-field appearance="outline">
                            <mat-label>First Name</mat-label>
                            <input type="text" matInput autocomplete="off" formControlName="firstName"
                              [errorStateMatcher]="matcher">
                            <mat-error *ngIf="userForm.get('firstName').hasError('required')">
                              First Name is required
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="dense-2">
                          <mat-form-field appearance="outline">
                            <mat-label>Middle Name</mat-label>
                            <input type="text" matInput autocomplete="off" formControlName="middleName"
                              [errorStateMatcher]="matcher">
                            <mat-error *ngIf="userForm.get('middleName').hasError('required')">
                              Middle Name is required
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="dense-2">
                          <mat-form-field appearance="outline">
                            <mat-label>Last Name</mat-label>
                            <input type="text" matInput autocomplete="off" formControlName="lastName"
                              [errorStateMatcher]="matcher">
                            <mat-error *ngIf="userForm.get('lastName').hasError('required')">
                              Last Name is required
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="dense-2">
                          <mat-form-field appearance="outline">
                            <mat-label>Contact Number</mat-label>
                            <input type="number" matInput autocomplete="off" formControlName="contactNumber"
                              [errorStateMatcher]="matcher">
                            <mat-error *ngIf="userForm.get('contactNumber').hasError('required')">
                              Contact Number is required
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="dense-2">
                          <mat-form-field appearance="outline">
                            <mat-label>Email Address</mat-label>
                            <input type="email" matInput autocomplete="off" formControlName="emailAddress"
                              [errorStateMatcher]="matcher">
                            <mat-error *ngIf="userForm.get('emailAddress').hasError('required')">
                              Email Address is required
                            </mat-error>
                            <mat-error *ngIf="userForm.get('emailAddress').hasError('email')">
                              Please enter a valid Email Address
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="col-md-4" *ngIf="!mode">
                        <div class="dense-2">
                          <mat-form-field appearance="outline">
                            <mat-label>Password</mat-label>
                            <input type="{{ hidePassword ? 'password' : 'text' }}" matInput autocomplete="off"
                              formControlName="password" [errorStateMatcher]="matcher">
                            <mat-icon matSuffix (click)="togglePasswordVisibility()" class="cursor-pointer"><ng-icon
                                name="{{ hidePassword ? 'heroEye' : 'heroEyeSlash' }}"></ng-icon></mat-icon>
                            <mat-error *ngIf="userForm.get('password').hasError('required')">
                              Password is required
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                      <div [ngClass]="mode ? 'col-md-8' : 'col-md-4'">
                        <div class="dense-2">
                          <mat-form-field appearance="outline">
                            <mat-label>Address</mat-label>
                            <input type="text" matInput autocomplete="off" formControlName="address"
                              [errorStateMatcher]="matcher">
                            <mat-error *ngIf="userForm.get('middleName').hasError('required')">
                              Address is required
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="dense-2">
                          <mat-form-field appearance="outline">
                            <mat-label>Select Country</mat-label>
                            <mat-select formControlName="countryId" [errorStateMatcher]="matcher">
                              <mat-option *ngFor="let country of countries" [value]="country.id">{{ country.name
                                }}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="userForm.get('countryId').hasError('required')">
                              Country is required
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
              <div class="d-flex col-md-12 p-0 justify-content-end">
                <button color="primary" class="outlined-btn" mat-raised-button *ngIf="mode != 'view'"
                  (click)="userForm.reset()" type="reset" [disabled]="isLoading">Reset</button>
                <button mat-raised-button color="accent" class="ml-3" matStepperNext>Next</button>
              </div>
            </form>
          </mat-step>
          <mat-step [stepControl]="organizationForm">
            <form [formGroup]="organizationForm">
              <mat-accordion>
                <mat-expansion-panel expanded hideToggle>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      Organizational Information
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="flex-wrap d-flex p-0">
                    <div class="col-md-4">
                      <div class="dense-2">
                        <mat-form-field appearance="outline">
                          <mat-label>Designation</mat-label>
                          <input type="text" matInput autocomplete="off" formControlName="designation"
                            [errorStateMatcher]="matcher">
                          <mat-error *ngIf="organizationForm.get('designation').hasError('required')">
                            Designation is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="dense-2">
                        <mat-form-field appearance="outline">
                          <mat-label>Organizational Level</mat-label>
                          <input type="text" matInput autocomplete="off" formControlName="organizationLevel"
                            [errorStateMatcher]="matcher">
                          <mat-error *ngIf="organizationForm.get('organizationLevel').hasError('required')">
                            Organizational Level is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="dense-2">
                        <mat-form-field appearance="outline">
                          <mat-label>Department</mat-label>
                          <input type="text" matInput autocomplete="off" formControlName="department"
                            [errorStateMatcher]="matcher">
                          <mat-error *ngIf="organizationForm.get('department').hasError('required')">
                            Department is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="dense-2">
                        <mat-form-field appearance="outline">
                          <mat-label>Date of Joining</mat-label>
                          <input matInput [matDatepicker]="picker" autocomplete="off" formControlName="dateOfJoining"
                            [errorStateMatcher]="matcher">
                          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                          <mat-datepicker #picker></mat-datepicker>
                          <mat-error *ngIf="organizationForm.get('dateOfJoining').hasError('required')">
                            Date of Joining is required
                          </mat-error>
                          <mat-error
                            *ngIf="organizationForm.get('dateOfJoining').invalid && !organizationForm.get('dateOfJoining').hasError('required')">
                            Date of Joining is invalid
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="dense-2">
                        <mat-form-field appearance="outline">
                          <mat-label>Reporting Manager</mat-label>
                          <mat-select formControlName="reportingManagerId"
                            (selectionChange)="selectedReportingManager($event)" [errorStateMatcher]="matcher">
                            <mat-option *ngFor="let user of users" [value]="user.id">{{ user.firstName + ' ' +
                              user.lastName
                              }}</mat-option>
                          </mat-select>
                          <mat-error *ngIf="organizationForm.get('reportingManagerId').hasError('required')">
                            Reporting Manager is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="dense-2">
                        <mat-form-field appearance="outline">
                          <mat-label>Assign Role</mat-label>
                          <mat-select formControlName="roleName" [errorStateMatcher]="matcher">
                            <mat-option *ngFor="let role of roles" [value]="role.id">{{ role.name }}</mat-option>
                          </mat-select>
                          <mat-error *ngIf="organizationForm.get('roleName').hasError('required')">
                            Assign Role is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
              <div class="d-flex col-md-12 justify-content-between p-0">
                <button mat-raised-button color="primary" class="outlined-btn" matStepperPrevious
                  [disabled]="isLoading">Back</button>
                <div>
                  <button color="primary" class="outlined-btn ml-3" mat-raised-button *ngIf="mode != 'view'"
                    (click)="organizationForm.reset()" type="reset" [disabled]="isLoading">Reset</button>
                  <button color="accent" mat-raised-button (click)="addUser(false)" *ngIf="mode != 'view'" class="ml-3"
                    [disabled]="isLoading">{{ mode ? 'Update' : 'Save' }}
                    <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
                  </button>
                  <button color="accent" mat-raised-button (click)="addUser(true)" *ngIf="!mode" class="ml-3"
                    [disabled]="isLoading">Save & Activate
                    <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
                  </button>
                </div>
              </div>
            </form>
          </mat-step>
        </mat-stepper>
      </ng-template>
    </mat-card-content>
  </mat-card>